import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { useAppSelector } from '../../hooks';
import { TProviderParserFileList, TProviderParserFileListResponse } from '../../types';
import { BACKEND_ADMIN_SOURCE_PROVIDER_PARSER_FILE } from '../../backend-paths';


export const providerParserFileListGetApi = createAsyncThunk(
	BACKEND_ADMIN_SOURCE_PROVIDER_PARSER_FILE,
	(payload: undefined, thunkApi) => {
		return HttpService.get<TProviderParserFileListResponse>(BACKEND_ADMIN_SOURCE_PROVIDER_PARSER_FILE).then(result => {
			return result.data;
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

type TInitialState = {
	isLoading: boolean;
	list: TProviderParserFileList;
	error?: HttpError;
};

const initialState: TInitialState = {
	isLoading: false,
	list: {
		items: [],
		count: 0,
	},
	error: undefined,
};

export const providerParserFileListSlice = createSlice({
	name: 'providerParserFileListSlice',
	initialState,
	reducers: {
		clearProviderParserFileList(state) {
			return { ...initialState, list: state.list };
		},

		setProviderParserFileList(state, action: PayloadAction<string[]>) {
			const list = {
				items: [...action.payload],
				count: action.payload.length || 0,
			};

			return { ...initialState, list };
		},
	},

	extraReducers: {
		[providerParserFileListGetApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[providerParserFileListGetApi.fulfilled.type]: (state, action: PayloadAction<TProviderParserFileList>) => {
			state.isLoading = false;
			state.list = action.payload;
			state.error = undefined;
		},

		[providerParserFileListGetApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useProviderParserFileListSelector = () => useAppSelector(state => state[providerParserFileListSlice.name]);

export const { clearProviderParserFileList, setProviderParserFileList } = providerParserFileListSlice.actions;
